import axios from 'axios'

const token = document.querySelector('meta[name="api-token"]')?.content
const integrationContext = document.querySelector('meta[name="integration-context"]')?.content

const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
}

if (integrationContext) {
    headers['X-Integration-Context'] = integrationContext
}

const axiosInstance = axios.create({
    headers,
})

export default axiosInstance
